import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
];

export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    redirect: "/home",
    hidden: true,
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" },
        hidden: true,
      },
    ],
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    hidden: true,
    meta: { title: "画面列表", icon: "ums" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户列表", icon: "ums-admin" },
        hidden: true,
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色列表", icon: "ums-role" },
        hidden: true,
      },
      {
        path: "code",
        name: "code",
        component: () => import("@/views/ums/code/index"),
        meta: { title: "编号列表" },
        hidden: true,
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: { title: "分配菜单" },
        hidden: true,
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "分配资源" },
        hidden: true,
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单列表", icon: "ums-menu" },
        hidden: true,
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add.vue"),
        meta: { title: "添加菜单" },
        hidden: true,
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: { title: "修改菜单" },
        hidden: true,
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: { title: "资源列表", icon: "ums-resource" },
        hidden: true,
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: { title: "资源分类" },
        hidden: true,
      },
    ],
  },
  {
    path: "/bBaseData",
    component: Layout,
    redirect: "/",
    name: "bBaseData",
    hidden: true,
    meta: { title: "业务基础数据管理", icon: "product-comment" },
    children: [
      {
        path: "employer",
        name: "employer",
        component: () => import("@/views/ums/bBaseData/employerList"),
        meta: { title: "用人单位" },
        hidden: true,
      },
      {
        path: "insuranceBase",
        name: "insuranceBase",
        component: () => import("@/views/ums/bBaseData/insuranceBaseList"),
        meta: { title: "社保系数" },
        hidden: true,
      },

    ]
  },
  {
    path: "/notice",
    component: Layout,
    redirect: "/",
    name: "notice",
    hidden: true,
    meta: { title: "通知管理", icon: "product-comment" },
    children: [
      {
        path: "file",
        name: "file",
        component: () => import("@/views/ums/notice/file/fileList"),
        meta: { title: "政策法规" },
        hidden: true,
      },
      {
        path: "notices",
        name: "notices",
        component: () => import("@/views/ums/notice/notices/noticeList"),
        meta: { title: "通知" },
        hidden: true,
      },
      {
        path: "noticeDetail",
        name: "noticeDetail",
        component: () => import("@/views/ums/notice/notices/noticeDetail"),
        meta: { title: "通知详情" },
        hidden: true,
      },

    ]
  },
  {
    path: "/contract",
    component: Layout,
    redirect: "/",
    name: "contract",
    hidden: true,
    meta: { title: "合同管理", icon: "product-comment" },
    children: [
      {
        path: "contractList",
        name: "contractList",
        component: () => import("@/views/ums/contract/contractList"),
        meta: { title: "合同列表" },
        hidden: true,
      },
      {
        path: "contractDetail",
        name: "contractDetail",
        component: () => import("@/views/ums/contract/contractDetail"),
        meta: { title: "合同详细信息" },
        hidden: true,
      },
    ]
  },
  {
    path: "/insurance-manage",
    component: Layout,
    redirect: "/",
    name: "insurance-manage",
    hidden: true,
    meta: { title: "员工社保管理", icon: "product-comment" },
    children: [
      {
        path: "payroll-setting-records",
        name: "payroll-setting-records",
        component: () => import("@/views/ums/payroll-setting-records/list"),
        meta: { title: "员工工资社保列表" },
        hidden: true,
      },
      {
        path: "personnel-changes",
        name: "personnel-changes",
        component: () => import("@/views/ums/personnel-changes/list"),
        meta: { title: "员工异动记录" },
        hidden: true,
      },
      {
        path: "maternityInsurance",
        name: "maternityInsurance",
        component: () => import("@/views/ums/contract/maternityInsurance"),
        meta: { title: "生育保险" },
        hidden: true,
      },
      {
        path: "injuryInsurance",
        name: "injuryInsurance",
        component: () => import("@/views/ums/contract/injuryInsurance"),
        meta: { title: "工伤保险" },
        hidden: true,
      },
    ]
  },
  {
    path: "/payroll-manage",
    component: Layout,
    redirect: "/",
    name: "payroll-manage",
    hidden: true,
    meta: { title: "员工工资管理", icon: "product-comment" },
    children: [
      {
        path: "payroll-grant-records",
        name: "payroll-grant-records",
        component: () => import("@/views/ums/payroll-grant-records/list"),
        meta: { title: "员工工资发放记录" },
        hidden: true,
      },
      {
        path: "dynamic",
        name: "dynamic",
        component: () => import("@/views/ums/bBaseData/dynamic/dynamicList"),
        meta: { title: "工资表动态条目" },
        hidden: true,
      },
    ]
  },
  {
    path: "/finance",
    component: Layout,
    redirect: "/",
    name: "finance",
    hidden: true,
    meta: { title: "财务管理", icon: "product-comment" },
    children: [
      {
        path: "transfer",
        name: "transfer",
        component: () => import("@/views/ums/finance/transfer/transferList"),
        meta: { title: "财务转账列表" },
        hidden: true,
      },
      {
        path: "bill",
        name: "bill",
        component: () => import("@/views/ums/finance/bill/billList"),
        meta: { title: "财务增值税开票" },
        hidden: true,
      },
      {
        path: "tax",
        name: "tax",
        component: () => import("@/views/ums/finance/tax/list"),
        meta: { title: "工资表查询列表" },
        hidden: true,
      },
      {
        path: "payment",
        name: "payment",
        component: () => import("@/views/ums/finance/payment/paymentList.vue"),
        meta: { title: "单位缴费通知单个人明细表" },
        hidden: true,
      },
    ]
  },

  {
    path: "/count",
    component: Layout,
    redirect: "/",
    name: "count",
    hidden: true,
    meta: { title: "统计", icon: "product-comment" },
    children: [
      {
        path: "contractCnt",
        name: "contractCnt",
        component: () => import("@/views/ums/contract/contractCnt"),
        meta: { title: "人数统计" },
        hidden: true,
      },
    ]
  },

  {
    path: "/staff",
    component: Layout,
    redirect: "noredirect",
    name: "staff",
    hidden: true,
    meta: { title: "派遣人员", icon: "product-comment" },
    children: [
      {
        path: "salary",
        name: "salary",
        component: () => import("@/views/ums/staff/salary"),
        meta: { title: "工资列表", closeFlag: true },
        hidden: true
      },
    ]
  },

  {
    path: "/members",
    component: Layout,
    redirect: "noredirect",
    name: "members",
    hidden: true,
    meta: { title: "派遣人员账号管理", icon: "product-comment" },
    children: [
      {
        path: "employeeMembers",
        name: "employeeMembers",
        component: () => import("@/views/ums/members/employeeMembers"),
        meta: { title: "派遣人员账号列表" },
        hidden: true
      },
    ]
  },

  { path: "*", redirect: "/404", hidden: true },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});



// WEBPACK FOOTER //
// ./src/router/index.js